import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
              观众热评
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              来自追剧达人的真实声音
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {commentItems.map((comment) => (
              <div
                key={comment.author}
                className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6"
              >
                <div className="flex items-center gap-3 mb-3 md:mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.author}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground-900">{comment.author}</p>
                    <p className="text-xs text-foreground-400">
                      正在追 <span className="text-primary-600">{comment.drama}</span>
                    </p>
                  </div>
                  <span className="text-xs text-foreground-300 whitespace-nowrap">
                    {comment.time}
                  </span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {comment.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}